var products_on_page = $('.products-on-page')
var next_url = products_on_page.data('next-url');
var page_size = products_on_page.data('pages');
var current_page = products_on_page.data('current-page');
var loader_more_btn = $('.js-load-more')
var loader_text = loader_more_btn.find('.load-more-text')
var loader = loader_more_btn.find('.loader')
var current_products = products_on_page.data('current-products');
$('.current_count').text(current_products);
$('.progress').css('width', (100/ page_size * current_page) + '%');
loader.hide();

if(current_page == page_size){
  loader_more_btn.attr('disabled', true);
  $('.progress-bar-warp').hide()
  $('.load-more_wrap').hide()
}
function loadMoreProducts(){
  loader_more_btn.attr('disabled', true);
  loader_text.hide()
  loader.show()

  $.ajax({
    url: next_url,
    type: 'GET',
    dataType: 'html',
    success: function(next_page){
      loader_more_btn.attr('disabled', false)
      loader.hide()
      loader_text.show()
      if(next_url){
        var new_products = $(next_page).find('.products-on-page');
        var new_url = new_products.data('next-url');
        var new_current_products = new_products.data('current-products');
        var new_current_page = new_products.data('current-page');
        current_products = current_products + new_current_products;
        current_page = new_current_page;
        next_url = new_url;

        products_on_page.append(new_products.html());
        $('.current_count').text(current_products);
        $('.progress').css('width', (100/ page_size * current_page) + '%');

        if(current_page == page_size){
          loader_more_btn.attr('disabled', true);
          $('.progress-bar-warp').hide()
          $('.load-more_wrap').hide()
        }
      }
    }
  })
}
    
